import { render, staticRenderFns } from "./LunchStatus.vue?vue&type=template&id=70f5f9f2&"
import script from "./LunchStatus.vue?vue&type=script&lang=js&"
export * from "./LunchStatus.vue?vue&type=script&lang=js&"
import style0 from "./LunchStatus.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports